import { useState } from 'react';
import PasswordGate from './PasswordGate';
import DemoLayout from './DemoLayout';
import './ValamarDemo.css';

export default function ValamarDemo() {
  const [unlocked, setUnlocked] = useState(false);

  if (!unlocked) {
    return (
      <div className="valamar-demo">
        <PasswordGate onUnlock={() => setUnlocked(true)} />
      </div>
    );
  }

  return (
    <div className="valamar-demo">
      <DemoLayout />
    </div>
  );
}
